import PropTypes from "prop-types";
// @mui
import { styled, useTheme } from "@mui/material/styles";
import {
  Stack,
  Typography,
  Rating,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
// components
import { useLocales } from "../../../../locales";
import { useLocation } from "react-router-dom";
import useResponsive from "../../../../hooks/useResponsive";
import { LocationIcon } from "src/assets/icons/LocationIcon";
import { ClockIcon } from "src/assets/icons/ClockIcon";
import { useState } from "react";
import OpeningHours from "src/components/OpeningHours";
import Iconify from "src/components/iconify";
// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  padding: theme.spacing(3),
  position: "relative",
}));

// ----------------------------------------------------------------------

VenueDetailsSummary.propTypes = {
  onGotoStep: PropTypes.func,
  product: PropTypes.object,
  isShortVersion: PropTypes.bool,
};

export default function VenueDetailsSummary({
  product,
  links,
  isShortVersion,
  ...other
}) {
  const {
    bookLink,
    rating,
    reviewsCount,
    priceRangeStart,
    priceRangeEnd,
    program,
  } = product.rating;
  const isMobile = useResponsive("down", "sm");
  const { name } = product.general;

  const address = product.address;
  const theme = useTheme();
  //uses the correct dictionary depending on the selected language
  const { translate } = useLocales();
  const { pathname } = useLocation();

  const getDollarSigns = (number) => {
    if (!number) return '';
    let dollars = '';
    for (var i = 0; i < number; i++) {
      dollars += '$';
    }
    return dollars;
  };

  const shouldDisplayAddress = () => {
    if (
      address.city &&
      address.street
    ) {
      return true;
    }
    return false;
  };

  return (
    <RootStyle {...other}>
      <Typography variant={isMobile ? "h3" : "h2"} component="h1" sx={{ mt: isMobile ? 0 : 8, mb: 2 }}>
        {name}
      </Typography>

      {shouldDisplayAddress() && (
        <ListItem
          sx={{
            pl: 0,
            ...(pathname.includes("/listings/") && {
              ":hover": {
                cursor: "pointer",
              },
            }),
          }}
          onClick={() => {
            if (pathname.includes("/listings/")) {
              window.open(address.googleLocationLink);
            }
          }}
        >
          <ListItemIcon>
            <LocationIcon color={theme.palette.text.primary}/>
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ variant: "subtitle1" }}
            primary={(address.venueName ? `${address.venueName}, ` : "") + `${address.street}, ${address.city}`}
          />
        </ListItem>
      )}

      {product.general.openingHours.length ? (
        <OpeningHours hours={product.general.openingHours} />
      ) : null
      }

      {
        program && !product.general.openingHours.length ? (
          <ListItem sx={{ pl: 0 }}>
            <ListItemIcon>
              <ClockIcon color={theme.palette.text.primary}/>
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ variant: "subtitle1" }}
              primary={program}
            />
          </ListItem>
        ) : null
      }

      {
        (rating || priceRangeStart) ? (
          <Stack
            sx={{ mt: 1, mb: isShortVersion ? 0 : 1 }}
            direction="row"
            spacing={1}
            alignItems={"center"}
          >
            {rating ? (<Stack
              direction="row"
              spacing={0.5}
              alignItems={"center"}
            >
              <Typography variant="subtitle1">{rating}</Typography>
              <Iconify icon="material-symbols:star" width={20} />
              <Typography variant="subtitle1">{`(${reviewsCount || 0})`}</Typography>
            </Stack>) : null}

            {rating && priceRangeStart ? <Typography variant="subtitle1">{' · '}</Typography> : null}
            {
              priceRangeStart ? (
                <Typography variant="subtitle1" >
                  {getDollarSigns(priceRangeStart)}
                  {priceRangeEnd ? ` - ${getDollarSigns(priceRangeEnd)}` : ''}
                </Typography>
              ) : null
            }
          </Stack>
        ) : null
      }



      {product.general.id === 'cm65af9ja0000l408r8o53rys' && <elevenlabs-convai agent-id="LpOqJ4syDF6nKVOBsD8h"></elevenlabs-convai>}
    </RootStyle >
  );
}
